export class LogSourceLocationDatadog {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LogSourceLocationDatadog.attributeTypeMap;
    }
    constructor() {
    }
}
